<template>
  <div  class="moduleStyle minHeight">
    <pageTitle title="微信群管理" />

    <basicList :config="basicListconfig" @search="searchEvent">
      <template v-slot:additionalFeatures>
        <div class="procurementDataSummary procurementDataSummary2">
          <ul>
            <li>
              <div>
                <div class="summaryTitle">活跃数</div>
                <div class="today summaryLine">
                  <p>{{acitve_num}}</p>
                </div>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">成交数</div>
                <div class="yesterday summaryLine">
                  <p>{{sell_num}}</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div style="height: 20px"></div>
      </template>

       <template v-slot:operation="row">
        <div style="display: flex; align-items: center">
          <div class="button button_modify" @click="editButton(row.row)">
            <i class="iconfont icon-bianji"></i> 编辑
          </div>
          <div class="button button_revoke" @click="deleteRows(row.row)">
            <i class="iconfont icon-shanchu"></i> 删除
          </div>
        </div>
      </template>
    </basicList>
    <formWindow
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>
  </div>
</template>

<script>
import {
  userGetlist,
  wxRoomDel,
  getshoplist,
  getUserShoplist,
  wxRoomInfoList
} from "@/api/basicConfiguration";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
import { getRoles } from "@/utils";
export default {
  name: "wxRoomManagement",
  components: {
    formWindow: () => import("./formWindow.vue"),
  },
  data() {
    return {
      compId: 0,
      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      // 列表组件参数
      basicListconfig: {
        loading: false,
        operationWidth: 200,
        search: [
          {
            label: "门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
          {
            label: "店员",
            type: "select",
            options: [],
            key: "sale_user_id",
          },
          {
            label: "状态",
            type: "select",
            options: [
              {
                label: "潜在",
                value: 0,
              },
              {
                label: "已成交",
                value: 1,
              },
            ],
            key: "status",
          },
          {
            label: "客户名称",
            type: "input",
            key: "keywords",
          },
          {
            label: "日期",
            type: "quickDate",
            key: "time",
          },
        ],
        data: [],
        column: [
          {
            label: "编号",
            prop: "id",
            width: 100,
          },
          {
            label: "群号",
            prop: "room_wxid",
            width: 100,
          },
          {
            label: "群名",
            prop: "room_name",
            width: 180,
          },
          {
            label: "关联客户",
            prop: "customer_name",
            width: 180,
          },
          {
            label: "关联门店",
            prop: "shop_name",
            width: 180,
          },
          {
            label: "关联店员",
            prop: "sale_name",
            width: 180,
          },
          {
            label: "最近互动",
            prop: "last_ai_time",
            width: 180,
          },
          {
            label: "最近交易时间",
            prop: "last_trade_time",
            width: 180,
          },
          {
            label: "推送",
            prop: "is_auto_push",
            filter: "is_auto_push",
          },
        ],
        sell_num:0,
        acitve_num:0,
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      dialogVisible: false,
      accountList: [],
      currentUserId: "",

      storeList: [],
      defaultProps: {
        children: "sub_list",
        label: "name",
      },
      systemPermissionDialogVisible: false,
      permissionTree: [],
      userPermissionOLDMap: {},
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    // 初始化列表内容
    this.getlist();
    this.obtainDataSource();
  },
  methods: {

    // 删除方法
    deleteRows(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        wxRoomDel({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 关闭弹窗
    closeThePopUpWindow() {
      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      this.getlist();
    },
    // 编辑弹窗
    editButton(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
    },
    // 搜索事件
    searchEvent(data, page) {
      if (page) {
        this.basicListconfig.page = page;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
          if (key == "time") {
            this.basicListconfig.searchParameters["begin_time"] = data[key]
              ? data[key][0]
              : null;
            this.basicListconfig.searchParameters["end_time"] = data[key]
              ? data[key][1]
              : null;
          }
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      this.basicListconfig.searchParameters.comp_id = this.compId;
      wxRoomInfoList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data;
          this.basicListconfig.total = res.count;
          this.sell_num=res.sell_num;
          this.acitve_num=res.acitve_num;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    // 获取门店列表
    obtainDataSource() {
     userGetlist({ limit: 10000, status: 0 }).then((res) => {
            if (res.code == 1) {
              this.basicListconfig.search.map((item) => {
                if (item.key == "sale_user_id") {
                  item.options = res.data.map((item) => {
                    return {
                      label: item.name,
                      value: item.id,
                    };
                  });
                }
                return item;
              });
            } else {
              this.$message.error(res.data.msg || "获取供应商数据源失败！");
            }
          });
      getshoplist({ limit: 10000, status: 0, comp_id: this.compId }).then(
        (res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                });
              }
            });
          } else {
            this.$message.error(res.data.msg || "获取门店数据源失败！");
          }
        }
      );
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/wxRoomManagement/index.vue